// extracted by mini-css-extract-plugin
export default {"container":"exitModal__container__bwnBz","title":"exitModal__title__VtOZV","button":"exitModal__button__JKbyn"};